import React,{useEffect} from "react";
import {Link} from "react-router-dom";
import "./caridoc-redesign.css";

const Icon=({name})=>{
 const common={viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:"1.8",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",focusable:"false"};
 const paths={
  book:<><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H11v16H6.5A2.5 2.5 0 0 0 4 21.5z"/><path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H13v16h4.5a2.5 2.5 0 0 1 2.5 2.5z"/></>,
  cases:<><rect x="3" y="6" width="18" height="14" rx="2"/><path d="M9 6V4h6v2"/><path d="M3 11h18"/><path d="M10 14h4"/></>,
  quiz:<><rect x="4" y="3" width="16" height="18" rx="2"/><path d="m8 12 2 2 5-5"/><path d="M8 17h8"/></>,
  fracture:<><path d="M7 3v5l3 2-2 4 3 2v5"/><path d="M17 3v5l-3 2 2 4-3 2v5"/><path d="M7 5h10"/><path d="M11 19h2"/></>,
  illustration:<><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8" cy="9" r="2"/><path d="m4 17 5-5 3 3 2-2 6 5"/></>,
  terms:<><path d="M5 4h14"/><path d="M8 4v16"/><path d="M5 20h6"/><path d="M14 9h5"/><path d="M14 13h5"/><path d="M14 17h4"/></>,
  drug:<><path d="M8.5 5.5a4.24 4.24 0 0 1 6 0l4 4a4.24 4.24 0 0 1-6 6l-4-4a4.24 4.24 0 0 1 0-6z"/><path d="m10 13 5-5"/></>,
  protocol:<><path d="M6 3h12v18H6z"/><path d="M9 7h6M9 11h6M9 15h4"/><path d="m16 16 1.5 1.5L21 14"/></>,
  subscribe:<><path d="m4 8 3 3 5-7 5 7 3-3-2 10H6z"/><path d="M6 21h12"/></>
 };
 return <svg {...common}>{paths[name]}</svg>
};

export default function Home(){
 useEffect(()=>{document.title="Caridoc.net | Dr. Dangleben's EMT Guide"},[]);
 const modules=[
  {title:"Chapters",desc:"Comprehensive, easy-to-follow content",path:"/chapters",kind:"book"},
  {title:"Case Studies",desc:"Real-life scenarios from the Caribbean",path:"/cases",kind:"cases"},
  {title:"Quiz",desc:"Test your knowledge and track progress",path:"/quiz-list",kind:"quiz"},
  {title:"Fracture Quiz",desc:"Bone injuries and management",path:"/fracture-quiz",kind:"fracture"},
  {title:"Illustrations",desc:"Visual learning for better retention",path:"/illustrations",kind:"illustration"},
  {title:"Medical Terms",desc:"Key terminology and definitions",path:"/medical-terms",kind:"terms"},
  {title:"Drug Appendix",desc:"Common medications in EMS",path:"/view-drug-refs",kind:"drug"},
  {title:"Protocols & Guidelines",desc:"Field-friendly Caribbean EMS guidance",path:"/protocols",kind:"protocol"},
  {title:"Subscribe",desc:"Get full access to all content",path:"/subscribe",kind:"subscribe"}
 ];
 return <div className="caridoc-premium-home">
  <section className="premium-hero">
   <div className="premium-hero-art" aria-hidden="true"><span className="hero-cross">+</span><span className="hero-pulse"><i/><i/><i/><i/><i/></span><span className="hero-islands">CARIBBEAN EMS</span></div>
   <div className="premium-hero-content">
    <div className="premium-kicker">DR. DANGLEBEN'S <span>EMT GUIDE</span></div>
    <h1>Caribbean-Focused<br/><em>EMS Education</em></h1>
    <h2>Train EMTs for the Caribbean – First<br/>Response on the Frontline</h2>
    <p>A complete, Caribbean-centered online portal for EMTs, paramedics, and students working on small islands, steep roads, and disaster-prone coastlines.</p>
    <div className="premium-hero-actions"><Link className="premium-primary" to="/chapters">Start Learning <b>→</b></Link></div>
   </div>
  </section>
  <section className="premium-modules"><div className="premium-grid">
   {modules.map(m=><Link to={m.path} className="premium-card" key={m.path}>
    <div className={"premium-card-visual "+m.kind}><Icon name={m.kind}/></div>
    <h3>{m.title}</h3><p>{m.desc}</p><i>→</i>
   </Link>)}
  </div></section>
  <section className="premium-feature">
   <div className="premium-feature-photo"><img src={require("../assets/emt3.png")} alt="Caribbean emergency medical care"/></div>
   <div className="premium-feature-copy"><small>FEATURED CONTENT</small><h2>EMS in the Caribbean</h2><p>Unique challenges. Real solutions.<br/>Learn how to provide high-quality pre-hospital care in resource-limited and high-risk environments.</p><Link to="/chapters">Explore Chapters <b>→</b></Link></div>
  </section>
  <section className="premium-why"><div className="premium-why-wrap"><small>WHY CARIDOC.NET?</small><div className="premium-why-grid">
   <div><span>♢</span><h3>Caribbean-Relevant</h3><p>Content designed for<br/>island and coastal settings</p></div>
   <div><span>♟</span><h3>Real-World Cases</h3><p>Based on actual<br/>scenarios</p></div>
   <div><span>◆</span><h3>Learn at Your Pace</h3><p>For EMTs, paramedics,<br/>and students</p></div>
   <div><span>◎</span><h3>Built by a Physician</h3><p>Created by<br/>Dr. Dale A. Dangleben, MD, FACS</p></div>
  </div></div></section>
 </div>
}